import { combineReducers } from 'redux';

import mapConfig from './MapConfig';
import container from './Container';
import imovel from './Imovel';
import smartMap from './SmartMap';
import publicSettings from './Public';
import lote from './Lote';
import arquivosDigitalizados from './ArquivosDigitalizados';
import arquivosGeraisFinancas from './ArquivosGeraisFinancas';
import logradouros from './Logradouros';

const rootReducer = combineReducers({
  mapConfig,
  container,
  lote, 
  imovel,
  smartMap,
  publicSettings,
  arquivosDigitalizados,
  arquivosGeraisFinancas,
  logradouros
});

export default rootReducer;